import { convertToDateTime } from '@/utils/date-time-utils'

// Helper function to convert result string to number array
export const getResultNumber = (result?: string): number[] => {
  if (!result) return []
  return result.split('').map((digit) => Number(digit))
}

export const createSection = (
  title: string,
  numbers: number[] | number[][],
): {
  title: string
  numbers: number[][]
} => ({
  title,
  numbers: Array.isArray(numbers[0])
    ? (numbers as number[][])
    : [numbers as number[]],
})

export const formatDateTime = (
  format: string,
  dateTime?: string,
  language?: string,
): string => {
  if (!dateTime) return ''
  return convertToDateTime(dateTime, format, language)
}
